import React from 'react'

const SubscriptionDetails = () => {
  return (
    <div>SubscriptionDetails</div>
  )
}

export default SubscriptionDetails